import { ActivityType } from "@repo/api/client";
import type { ActivityLogItem } from "./db/schema";

/**
 * How a referral went out, read from its `ReferralSent` activity items: not at
 * all, by Skyway (a Libretto send), or by staff outside Skyway. A Skyway send
 * wins over an outside one, since it is the record we know is real.
 */
export type ReferralSentState = "not_sent" | "skyway" | "outside";

export function referralSentState(
	items: readonly ActivityLogItem[],
): ReferralSentState {
	let outside = false;
	for (const item of items) {
		if (item.payload.type !== ActivityType.ReferralSent) continue;
		if (!item.payload.sentOutsideSkyway) return "skyway";
		outside = true;
	}
	return outside ? "outside" : "not_sent";
}

/** "2026-09-29" as "Sep 29, 2026", without shifting the day across timezones. */
export function formatSentDate(sentDate: string): string {
	return new Date(`${sentDate}T12:00:00Z`).toLocaleDateString("en-US", {
		month: "short",
		day: "numeric",
		year: "numeric",
		timeZone: "UTC",
	});
}
